import { useCallback, useEffect, useState } from 'react';

/**
 * Bridges the Pin Board side-nav item (rendered by Layout) and the pinboard
 * screen (rendered by the router) — they have no shared parent below Layout.
 *
 * Needed because the `Pinboard` module from `@axtria/hqi-genai` owns "board list
 * vs. opened board" as its own local state, so clicking the nav while a board is
 * open re-navigates to the same path and nothing happens.
 */
// Module-level so every consumer shares one counter.
let resetCount = 0;
let listeners: Array<(_count: number) => void> = [];

export const usePinboardReset = () => {
  const [pinboardResetCount, setPinboardResetCount] = useState(resetCount);

  useEffect(() => {
    listeners.push(setPinboardResetCount);
    return () => {
      listeners = listeners.filter((listener) => listener !== setPinboardResetCount);
    };
  }, []);

  const triggerPinboardReset = useCallback(() => {
    resetCount += 1;
    listeners.forEach((listener) => listener(resetCount));
  }, []);

  return { pinboardResetCount, triggerPinboardReset };
};
